import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { JoinInquiryForm } from '../components/JoinInquiryForm'
import { ResponsiveImage } from '../components/ResponsiveImage'
import { images } from '../data/images'

const professionalTypes = [
  { number: '01', title: 'Hair stylists', description: 'Independent artists focused on thoughtful cutting, styling, and client care.' },
  { number: '02', title: 'Colorists', description: 'Professionals building a practice around dimensional color and technical craft.' },
  { number: '03', title: 'Extension specialists', description: 'Artists offering personalized length, density, and transformation services.' },
  { number: '04', title: 'Beauty professionals', description: 'Skincare, brow, lash, and related professionals looking for a polished setting.' },
]

export function JoinTeam() {
  return (
    <>
      <section className="join-hero">
        <div className="join-hero__image" aria-hidden="true">
          <ResponsiveImage image={images['gallery-02']} alt="" sizes="(max-width: 860px) 100vw, 56vw" objectPosition="48% center" priority />
        </div>
        <div className="join-hero__shade" aria-hidden="true" />
        <div className="shell join-hero__content">
          <span className="join-hero__label">Diamond Salon / Independent Professionals</span>
          <h1 className="join-hero__title" aria-label="Join the collective">
            <span>Join</span><span>The</span><span><em>Collective.</em></span>
          </h1>
          <div className="join-hero__intro">
            <p>Work independently. Grow your clientele. Do it in a polished Diamond Salon environment.</p>
            <Link className="button button--light" to="/join-our-team#join-inquiry">Inquire about a space <ArrowRight /></Link>
          </div>
        </div>
      </section>

      <section className="join-independence section shell">
        <div className="join-independence__heading reveal reveal--heading">
          <span className="editorial-index">01 / Your practice</span>
          <h2>Your business.<br /><em>Your chair.</em></h2>
        </div>
        <div className="join-independence__copy reveal">
          <p>Diamond Salon offers independent beauty professionals a refined place to build their own practice while working alongside an established salon community.</p>
          <p>Bring your point of view, your standards, and the client relationships you are ready to grow. We provide the professional setting; you shape what comes next.</p>
          <Link className="text-link" to="/join-our-team#join-inquiry">Start a conversation <ArrowRight /></Link>
        </div>
      </section>

      <section className="join-space section">
        <div className="shell join-space__grid">
          <div className="join-space__heading reveal reveal--heading">
            <span className="editorial-index editorial-index--light">02 / The space</span>
            <h2>A polished place<br />to do <em>your best work.</em></h2>
            <p>Modern stations, thoughtful treatment spaces, and a welcoming client environment in an established San Juan Capistrano location.</p>
          </div>
          <div className="join-space__image join-space__image--large reveal reveal--image">
            <ResponsiveImage image={images['gallery-02']} alt="Bright styling stations inside Diamond Salon" sizes="(max-width: 860px) 100vw, 58vw" objectPosition="48% center" />
          </div>
          <div className="join-space__image join-space__image--small reveal reveal--image">
            <ResponsiveImage image={images['gallery-03']} alt="Private treatment room inside Diamond Salon" sizes="(max-width: 620px) 44vw, 27vw" objectPosition="46% 58%" />
          </div>
        </div>
      </section>

      <section className="join-professionals section shell">
        <div className="join-professionals__intro reveal reveal--heading">
          <span className="editorial-index">03 / The collective</span>
          <h2>Built for independent<br /><em>beauty professionals.</em></h2>
          <p>The opportunity may be a fit for professionals who value independence, a client-ready environment, and the energy of working near other experienced artists.</p>
        </div>
        <div className="join-professionals__list reveal">
          {professionalTypes.map((item) => (
            <article key={item.number}>
              <span>{item.number}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="join-availability section">
        <div className="shell join-availability__grid reveal reveal--heading">
          <span className="editorial-index editorial-index--light">04 / Availability</span>
          <h2>A space<br />for what’s<br /><em>next.</em></h2>
          <div>
            <p>Interested in joining Diamond Salon? Tell us about your work and the type of space you are looking for. Availability is confirmed through a conversation with the salon.</p>
            <Link className="button button--light" to="/join-our-team#join-inquiry">Check availability <ArrowRight /></Link>
          </div>
        </div>
      </section>

      <section id="join-inquiry" className="join-inquiry section shell" aria-labelledby="join-inquiry-title">
        <div className="join-inquiry__intro reveal reveal--heading">
          <span className="editorial-index">05 / Introduce yourself</span>
          <h2 id="join-inquiry-title">Let’s start a<br /><em>conversation.</em></h2>
          <p>This is an initial availability inquiry—not a long application. Share a little about your work and the salon will follow up about fit and current space options.</p>
        </div>
        <div className="join-inquiry__form reveal">
          <JoinInquiryForm />
        </div>
      </section>
    </>
  )
}
